(() => {
  const isAdyenPage = document.querySelectorAll('.ph-adyenPayment__parent');

  /**
   * @param {object} response - json object
   * @param {object} dropin - json object
   * @returns {void} - nothing
   * @example handleSubmission()
   */
  const handleServerResponse = function(response, dropin) {
    if (response.resultCode !== 'RedirectShopper' && response.redirectUrl) {
      location.href = escape(response.redirectUrl);
    } else if (response.action.method === 'POST') {
      dropin.handleAction(response.action);
    } else {
      location.replace(response.action.url);
    }
  };

  /**
   * @param {object} state - json object
   * @param {object} dropin - json object
   * @param {string} url - holds the url
   * @returns {void} - nothing
   * @example callServer()
   */
  const handleSubmission = function(state, dropin, url) {
    const totalPrice = document.querySelector('.ph-checkout__yourorder_totalpriceheading').lastElementChild.textContent.replace('$', ''),
        cartCode = document.querySelector('.ph-adyenCartId').textContent,
        currencyCode = document.querySelector('.ph-adyenCurrency').textContent;

    const dataValue = state.data;
    let finalValue = {};

    if (dataValue.paymentMethod.type === 'ideal') {
      finalValue = {
        type: dataValue.paymentMethod.type,
        issuer: dataValue.paymentMethod.issuer,
        currency: currencyCode,
        cartId: cartCode,
        value: totalPrice * 100
      };
    } else if (dataValue.paymentMethod.type === 'ach') {
      finalValue = {
        type: dataValue.paymentMethod.type,
        currency: currencyCode,
        cartId: cartCode,
        value: totalPrice * 100,
        ownerName: dataValue.paymentMethod.ownerName,
        accountNumber: dataValue.paymentMethod.encryptedBankAccountNumber,
        locationId: dataValue.paymentMethod.encryptedBankLocationId
      };
    } else {
      finalValue = {
        type: dataValue.paymentMethod.type,
        currency: currencyCode,
        cartId: cartCode,
        value: totalPrice * 100,
        cardNumber: dataValue.paymentMethod.encryptedCardNumber,
        expiryMonth: dataValue.paymentMethod.encryptedExpiryMonth,
        expiryDate: dataValue.paymentMethod.encryptedExpiryYear,
        holderName: dataValue.paymentMethod.holderName,
        cvv: dataValue.paymentMethod.encryptedSecurityCode,
        acceptHeader: dataValue.browserInfo.acceptHeader,
        colorDepth: dataValue.browserInfo.colorDepth,
        javaEnabled: dataValue.browserInfo.javaEnabled,
        language: dataValue.browserInfo.language,
        screenHeight: dataValue.browserInfo.screenHeight,
        screenWidth: dataValue.browserInfo.screenWidth,
        timeZoneOffset: dataValue.browserInfo.timeZoneOffset,
        userAgent: dataValue.browserInfo.userAgent
      };
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(finalValue)
    };

    /* eslint-disable promise/catch-or-return */
    fetch(url, requestOptions)
    /* eslint-enable promise/catch-or-return */
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return handleServerResponse(response, dropin);
      });
  };

  /**
   * @example handleSubmission()
   * @returns {void} - Nothing
   */
  const initCheckout = function() {
    const type = 'dropin',
        isAnonymous = document.querySelectorAll('.ph-page-AnonymousPaymentPage');

    const paymentMethodsResponse = JSON.parse(document.querySelector('#paymentMethods').value);
    const pConfig = paymentMethodsResponse.paymentConfig;

    if (paymentMethodsResponse.apiError === 'undefined' || paymentMethodsResponse.apiError === null) {
      const translations = {
        'en-US': JSON.parse(document.querySelector('#translation').textContent),
        'en-GB': JSON.parse(document.querySelector('#translation').textContent),
        'de-DE': JSON.parse(document.querySelector('#translation').textContent),
        'it-IT': JSON.parse(document.querySelector('#translation').textContent),
        'hu-HU': JSON.parse(document.querySelector('#translation').textContent),
        'fr-FR': JSON.parse(document.querySelector('#translation').textContent),
        'au-AU': JSON.parse(document.querySelector('#translation').textContent),
        'sg-SG': JSON.parse(document.querySelector('#translation').textContent),
        'in-IN': JSON.parse(document.querySelector('#translation').textContent)
      };

      const configuration = {
        paymentMethodsResponse,
        clientKey: pConfig.clientKey,
        locale: pConfig.locale,
        environment: pConfig.environment,
        showPayButton: true,
        translations,
        paymentMethodsConfiguration: {
          card: {
            hasHolderName: true,
            holderNameRequired: true,
            name: document.querySelector('.ph-adyen-creditdebit').textContent,
            styles: {
              placeholder: {
                color: '#c2cacc',
                fontSize: '18px'
              }
            }
          },
          ach: {
            billingAddressRequired: false
          }
        },
        onSubmit: (state, dropin) => {
          if (state.isValid) {
            if (isAnonymous.length > 0) {
              handleSubmission(state, dropin, '/anonymousCheckout/multi/initiatePayment');
            } else {
              handleSubmission(state, dropin, '/checkout/multi/initiatePayment');
            }
          }
        },
        onAdditionalDetails: (state, dropin) => {
          handleSubmission(state, dropin, '/checkout/multi/submitAdditionalDetails');
        }
      };

      /* eslint-disable no-undef */

      const checkout = new AdyenCheckout(configuration);
      /* eslint-enable no-undef */

      checkout.create(type).mount(document.querySelector('#payment'));
    }
  };

  if (isAdyenPage.length > 0) {
    initCheckout();
  }
})();
